import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DropDownButton } from '@progress/kendo-angular-buttons';
import { KENDO_APPBAR } from '@progress/kendo-angular-navigation';
import { clearStorage } from 'src/app/core/helpers/storage';
import { SidebarComponent } from 'src/app/shared/components/sidebar/sidebar.component';
import { environment } from 'src/environments/environment';
import { AppSettings } from '../core/common/app.settings';
import { Auth } from '../core/common/auth';
import { Language } from '../core/contracts';
import { DataServices } from '../data/data.services';
import { BaseComponent } from '../shared/components/base-component/base.component';
import { NotificationsComponent } from './notifications/notifications.component';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css'],
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, KENDO_APPBAR, DropDownButton, TranslateModule, NotificationsComponent],
})
export class NavigationComponent extends BaseComponent implements OnInit {
  en = Language.en;
  ar = Language.ar;
  translationKeys = this.translation.Common;
  version = environment.version;
  languages = [
    { text: 'العربية', language: Language.ar },
    { text: 'English', language: Language.en },
  ];

  agencyName: string | undefined;
  get actions() {
    return [
      {
        text: this.ui.translate.instant(this.translationKeys.SignOut),
        click: (item: unknown): void => {
          this.logout();
        },
      },
    ];
  }
  constructor(private appSettings: AppSettings, private router: Router, private auth: Auth, private data: DataServices) {
    super();
    // NOTE: quirky workaround for dialog not opening (e.g: showError for failed a request) unless triggered first from within a component, should investigate and fix
    // this.ui.showMessage().then(dialog => dialog.close());
  }
  override ngOnInit() {
    this.auth.getAgencyName(this.ui.translate).subscribe(name => {
      this.agencyName = name;
    });
  }
  getCurrentLanguageName() {
    return this.translation.Languages[this.settings?.language || Language.en];
  }
  selectLanguage(data: { language: Language }) {
    this.settings.language = data.language;
    this.appSettings.setLanguage(this.settings);
    setTimeout(() => window.location.reload(), 100);
  }
  async logout() {
    await this.auth.logout();
    await this.data.dispose();
    await clearStorage();
    this.router.navigate(['/']);
  }
}
